import { Module } from 'vuex'
import { GlobalDataProps, actionWrapper } from './index'
import { ListData, RespData } from './respTypes'
export interface ExampleData {
  _id: string;
  name: string;
  desc?: string;
  category?: string;
}
export interface CategoryData {
  _id: string;
  name: string;
  desc: string;
  coverImage: string;
  examples?: ExampleData[]
}
export interface ExampleProps {
  data: ExampleData[];
  categories: CategoryData[];
  dataIsLoaded: boolean;
  categoryIsLoaded: boolean;
}
const example: Module<ExampleProps, GlobalDataProps> = {
  state: {
    data: [],
    categories: [],
    dataIsLoaded: false,
    categoryIsLoaded: false
  },
  mutations: {
    getExamples(state, rawData: ListData<ExampleData[]>) {
      const { data } = rawData
      state.data = data.data
      state.dataIsLoaded = true
    },
    getCategories(state, rawData: ListData<CategoryData[]>) {
      const { data } = rawData
      state.categories = data.data
      state.categoryIsLoaded = true
    },
    createCategory(state, rawData: RespData<CategoryData>) {
      const { data } = rawData
      state.categories.push(data)
    },
    updateCategory(state, rawData: RespData<CategoryData>) {
      const { data } = rawData
      const index = state.categories.findIndex(resume => resume._id === data._id)
      console.log(index)
      if (index > -1) {
        state.categories[index] = data
      }
    },
    deleteCategory(state, { payload }: RespData<any>) {
      if (payload && payload.urlParams) {
        const { urlParams } = payload
        state.categories = state.categories.filter(category => category._id !== urlParams.id)
      }      
    }
  },
  actions: {
    getExamples: actionWrapper('/api/examples', 'getExamples', { loadedKey: 'dataIsLoaded' }),
    getCategories: actionWrapper('/api/categories', 'getCategories', { loadedKey: 'categoryIsLoaded' }),
    createCategory: actionWrapper('/api/categories', 'createCategory', { method:'POST' }),
    updateCategory: actionWrapper('/api/categories/:id', 'updateCategory', { method: 'patch', disableCaching: true }),
    deleteCategory: actionWrapper('/api/categories/:id', 'deleteCategory', { method: 'delete', disableCaching: true })
  },
  getters: {
    getCategoryByIndex: (state) => (index:number) => {
      return state.categories[index]
    }
  }
}

export default example